import React from 'react';
import './article.css';

const Article = ({ imgUrl, date, text, link }) => (
  <div className="taasa__blog-container_article">
    <div className="taasa__blog-container_article-image">
      <img src={imgUrl} alt="blog_image" width="640" height="480" />
    </div>
    <div className="taasa__blog-container_article-content">
      <div>
        <p>{date}</p>
        <h3>{text}</h3>
      </div>
      <a href={link}><p>Read full article</p></a>
    </div>
  </div>
);

export default Article;
